import { showBanner } from './../template/template.js'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import './style.min.css'

const isFR = document.documentElement.lang == 'fr'

/* -------- START GALLERY -------- */
const NUM_PHOTOS = 65
const NUM_TO_SHOW = 10
const images = []
const gallery = document.querySelector('.gallery')
gallery.style.height = `${NUM_TO_SHOW * 50}vh`

// Create image element and its container
for (let i = 1; i <= NUM_PHOTOS; i++) {
    let newImg = document.createElement('img')
    // Assign an index to that image
    newImg.index = i
    images.push(newImg)

    let imgContainer = document.createElement('div')
    imgContainer.classList.add('img-container')
    imgContainer.appendChild(newImg)
}

// Randomize array
function shuffle(array) {
    let len = array.length
    let i = null
    let temp = null

    // While there remain elements to shuffle
    while (len > 0) {
        // Pick a remaining element
        i = Math.floor(Math.random() * len--)

        // And swap it with the current element
        temp = array[len]
        array[len] = array[i]
        array[i] = temp
    }
}
shuffle(images)

// Create a textbox element
const textBox = document.createElement('div')
textBox.classList.add('text-box')
textBox.innerHTML = isFR
    ? '<div class="text" style="opacity: 0;">Visitez notre <a href="https://instagram.com/coda.ccs" target="_blank" rel="noopener noreferrer">page Instagram</a> pour plus de photos!</div>'
    : '<div class="text" style="opacity: 0;">Check out our <a href="https://instagram.com/coda.ccs" target="_blank" rel="noopener noreferrer">Instagram page</a> for more!</div>'

// Initialize ScrollTrigger
gsap.registerPlugin(ScrollTrigger)
for (let j = 0; j < NUM_TO_SHOW; j++) {
    let img = images[j]
    // Load first two images
    if (j === 0 || j === 1) {
        loadImg(img, j)
    }
    // Add image to DOM and create animation
    gallery.appendChild(img.parentElement)
}
function loadImg(currentImg, index) {
    currentImg.srcset = `/images/photos/360/${currentImg.index}.jpg 360w, /images/photos/720/${currentImg.index}.jpg 720w, /images/photos/1080/${currentImg.index}.jpg 1080w`
    currentImg.alt = `Photo number ${currentImg.index}`

    let imgTween = gsap.to(currentImg.parentElement, {
        opacity: 1,
        duration: 0.4,
        onStart: () => {
            // Load the next image
            if (index + 2 < NUM_TO_SHOW) {
                loadImg(images[index + 2], index + 2)
            }
        },
    })
    ScrollTrigger.create({
        animation: imgTween,
        trigger: currentImg,
        start: `38% 55%`,
        end: `100% -25%`,
        toggleActions: 'play none none reverse',
        invalidateOnRefresh: true,
        once: true,
        // Fade in text when the last image exits the window
        onLeave:
            index === NUM_TO_SHOW - 1
                ? () => {
                      gsap.to('.text', {
                          opacity: 1,
                          ease: 'linear',
                          duration: 0.5,
                      })
                  }
                : null,
    })
}
gallery.appendChild(textBox)
/* -------- END GALLERY -------- */

/* -------- START SIB -------- */
const SIB_URL =
    'https://0ee8635e.sibforms.com/serve/MUIEAILgKMacGcnsjQRBYvbY7FAT2eOTAZGM-dQZL9drV0XvIwjNxDtAHA68lvPorkClABzfEKP-TTRurDklR0qJq3Kt8rDrfTA6tP_NnljQV_OAUFT4GEpfXtMhkFXco0Z_GQvCg8QxkBw-TBMeHn9LVXa8CpYrQFVbFuKZEZA2Rf9YAjubfby9aHTojv2gi5m_PFZvJ9pBYWC0'

const form = document.querySelector('#sib-form')
const userEmail = document.querySelector('#user-email')
const submitButton = document.querySelector('#sign-up-button')

let formSubmitted = false

form.addEventListener('submit', (e) => {
    e.preventDefault()

    if (formSubmitted) return

    if (!validateEmail(userEmail.value)) {
        showBanner('Please enter a valid email address.', 'Veuillez entrer une adresse courriel valide.', 0)
        return
    }

    fetch(SIB_URL, {
        method: 'POST',
        mode: 'no-cors',
        header: {
            'Content-Type': 'application/json',
        },
        body: getFormData(),
    })
        .then(() => {
            formSubmitted = true
            userEmail.disabled = true
            submitButton.disabled = true
            showBanner('Success!', 'Bien reçu!')
        })
        .catch((error) => {
            showBanner('An error occurred :(', 'Une erreur est survenue :(', 0)
            console.error(error)
        })
})

function getFormData() {
    let dataToPost = new FormData()

    dataToPost.append('email_address_check', document.querySelector('#email_address_check').value)
    dataToPost.append('locale', document.querySelector('#locale').value)
    dataToPost.append('html_type', document.querySelector('#html-type').value)
    dataToPost.append('EMAIL', userEmail.value)

    return dataToPost
}

function validateEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
}
/* -------- END SIB -------- */
